import React from 'react'
import {Box} from 'grommet'
import LabUserForm from '../../components/labUserForm'
import EditUserForm from '../../components/editUserForm'
import {withRouter} from 'react-router-dom'
import { API,Auth } from 'aws-amplify';
import {LoadLayer, NavigationSnackBar} from '../../components/utils/shared/shared'
import {APIRequest} from '../../components/utils/shared/requests'

class EditUser extends React.Component {

    state = {
        load: true,
        value: {username: '', password: '', email: '', enabled:true},
        userStatus: false,
        locationType: '',
        customer: {name: 'Select Customer...', primary_contact_person: '',primary_contact_email: '', primary_contact_phone: '',address:{AddressLineOne: '', AddressLineTwo: '',AddressLineThree: '',City: '',PostCode: '',Country: ''}},
        lab: {name: 'Select Lab...', primary_contact_person: '',primary_contact_email: '', primary_contact_phone: '',address:{AddressLineOne: '', AddressLineTwo: '',AddressLineThree: '',City: '',PostCode: '',Country: ''}},
        userRole: ''
    }

    componentDidMount(){
      APIRequest(`/auth/get_user?username=${this.props.location.state.username}`).then(result => {
        if (result.location_type === 'lab'){
          this.setState({
            value:{username: result.username, password: '', email: result.user_attributes.pop().value, enabled: result.enabled},
            load:false,
            lab:result.location,
            locationType: 'lab',
            userRole: (result.username === 'SAMPLELOG' ? 'SuperAdmin' : 'Lab'),
            userStatus: result.enabled
          })
        } else {
          this.setState({
            value:{username: result.username, password: '', email: result.user_attributes.pop().value,enabled: result.enabled},
            load:false,
            customer:result.location,
            lab: result.lab_location,
            locationType: 'customer',
            userRole: 'Customer',
            userStatus: result.enabled
          })
        }
      })
    }

    handleCustomerChange = (event) => {
        this.setState({customer: event});
      };

      handleChange = (event) => {
          this.setState({value: event});
        };

        handleLabChange = (event) => {
          this.setState({lab: event});
        };
  
  
        returnUserStatus = () => {
          if (this.state.userStatus === this.state.value.enabled){
            return this.state.userStatus
          } else {
            return this.state.value.enabled
          }
        }

    handleSubmit = () => {
      this.setState({load: true})
      const login = {username: this.state.value.username, password: this.state.value.password, email: this.state.value.email, customer: this.state.customer, lab: this.state.lab, enabled: this.returnUserStatus()}
      console.log(login)
      const whichUrl = (this.props.user === 'SuperAdmin' ? "/auth/update_user" :"/auth/lab_update_user")
      Auth.currentSession().then(session => {
        API
        .post("LabShip", whichUrl,
        { headers: { 
          Authorization: session.idToken.jwtToken,
        }, 
        body:login})
        .then(user => {
           this.setState({error: false ,load: false})
           if (this.props.user === 'SuperAdmin'){
            this.props.history.push({
              pathname: '/admin/users/all',
            })
           } else {
            this.props.history.push({
              pathname: '/users/all',
            })
           }
       
       }).catch(err => this.setState({errorMessage: err, error: true}))
      })
      }

      ReturnUserRole = () => {
        
      }
    
    render(){
        const {load,value, customer,lab,locationType,userRole} = this.state;
        const labAccountName = this.props.location.state.lab
        return ( 
          <Box>
              {(load ? <LoadLayer load={load} label={"Loading User..."} /> : 
                <Box>
                   <NavigationSnackBar title={`Edit User: ${this.state.value.username}`} user={this.props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'Users', link: '/users/all'}]}  />
                    <Box direction='row' justify="center" flex="grow">
                    {this.props.user === 'SuperAdmin' ? <EditUserForm userRole={userRole} labName={labAccountName} locationType={locationType} handleSubmit={this.handleSubmit} handleChange={this.handleChange} handleLabChange={this.handleLabChange} handleCustomerChange={this.handleCustomerChange} value={value} load={load} lab={lab} customer={customer}/> :<LabUserForm label={"Update User"} handleSubmit={this.handleSubmit} handleChange={this.handleChange} handleCustomerChange={this.handleCustomerChange} value={value} load={load} customer={customer}/>}   
                    </Box>
                </Box>
              )}
          </Box>
          )
    }
}

export default withRouter(EditUser)
